module.exports = __webpack_public_path__ + "img/a4d1b5d.jpg";